import React, { useState, ChangeEvent } from "react";
import BaseDialog from "../../modelDialogs/BaseDialog";
import "../../App";

import { updateUserDetails } from "../account/Login/Login";

export default function LoadNewProfilePicture(props: { image: string }) {
  const [profilePicture, setProfilePicture] = useState(props.image);
  const [imageUpdated, setImageUpdated] = useState(false);

  function onLoadProfilePicture() {
    const elem = window.document.createElement("input");
    elem.type = "file";
    document.body.appendChild(elem);

    elem.onchange = (ev) => {
      downloadImage(ev as unknown as ChangeEvent<HTMLInputElement>);
    };
    elem.click();
  }
  function downloadImage(e: ChangeEvent<HTMLInputElement>) {
    function resizeImage(base64Str: string) {
      return new Promise((resolve) => {
        let img = new Image();
        img.src = base64Str;
        img.onload = () => {
          let canvas = document.createElement("canvas");
          const maxWidth = 400;
          const maxHeight = 400;
          let width = img.width;
          let height = img.height;

          if (width < height) {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          } else {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          }
          canvas.width = width;
          canvas.height = height;
          let ctx = canvas.getContext("2d");
          if (ctx) ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL());
        };
      });
    }

    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        var base64data = reader.result;
        if (typeof base64data == "string") {
          // resize
          resizeImage(base64data).then((result) => {
            setProfilePicture(result as string);
            setImageUpdated(true);
          });
        }
      };
    }
  }

  return (
    <BaseDialog
      dialogId="loadNewProfilePicture" // no itx
      title={state.translate("loadNewProfilePicture.changeProfilePicture", "Profilbild ändern")}
      abortCaption={state.translate("loadNewProfilePicture.dontChange", "Nicht ändern")}
      okCaption={state.translate("loadNewProfilePicture.change", "Profilbild ändern")}
      noOkButton={!imageUpdated}
      onClose={() => {
        return true;
      }}
      onOk={() => {
        // here save the new url
        if (profilePicture) {
          localStorage.setItem(`profilePicture${state.loggedInUser?.id || ""}`, profilePicture);
          let user = localStorage.getItem("user");
          if (user && user != "") {
            let userDetails = JSON.parse(user);
            userDetails["profile_pic"] = profilePicture; // no itx
            localStorage.setItem("user", JSON.stringify(userDetails));
          }
          updateUserDetails({ profilePic: profilePicture });
          (document.getElementsByClassName("profP")[0] as any).src = profilePicture;
          return true;
        } else {
          return false;
        }
      }}
    >
      <div style={{ width: "250px", textAlign: "center" }}>
        {state.translate("loadNewProfilePicture.profilePictureChange?", "willst du dein Profilbild ändern?")}
        <div
          className="user-menu-img"
          style={{ marginTop: "5px" }}
          onClick={() => {
            onLoadProfilePicture();
          }}
        >
          <img
            className="item-shadow item-fade"
            style={{
              borderRadius: "50%",
              width: "200px",
              height: "200px",
              background: "var(--white2)",
              borderColor: "var(--knxColorBlack)",
              cursor: "pointer",
              objectFit: "contain",
            }}
            src={profilePicture}
          ></img>
          <div className="text-over-fade">
            <i className="las la-camera" style={{ fontSize: "32px" }}></i>
            <br />
            {state.translate("loadNewProfilePicture.changeProfilePicture", "Change Profile Picture")}
          </div>
        </div>
        {/* <button
          className="button"
          onClick={() => {
            onLoadProfilePicture();
          }}
        >
          <i className="las la-upload"></i>
        </button> */}
      </div>
    </BaseDialog>
  );
}
